// Centralized route constants
const ROUTES = {
  LOGIN: "/login",
  HOME: "/",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
};

export default ROUTES;
